// extracted by mini-css-extract-plugin
export default {"container":"fSG9vgYP"};